var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataset-audio-categorization"},[_c('classification'),_vm._m(0),_c('div',{staticClass:"popup-list"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"picture-box"})])
}]

export { render, staticRenderFns }